/**
 * Converts the legacy lazysizes markup in migrated product descriptions into
 * native browser lazy loading.
 *
 * The imported `.wysiwyg` content ships images and iframes as
 * `<img src="<placeholder>" data-src="<real>" class="lazyload">`, which used to
 * be resolved by the lazysizes library. The Hyper theme doesn't run lazysizes,
 * so without this the real media never loads. For each affected element we add
 * `loading="lazy"` FIRST (so the new source is fetched lazily), then move
 * `data-src` -> `src` (and `data-srcset` -> `srcset` when present), overwriting
 * the placeholder.
 *
 * Scoped to `.wysiwyg` so it never interferes with the theme's own media
 * handling. Loaded via snippets/nwf-wysiwyg.liquid.
 */
(() => {
    const nativeLazyLoad = (root = document) => {
        const elements = root.querySelectorAll('.wysiwyg [data-src], .wysiwyg [data-srcset]');

        elements.forEach((el) => {
            const tag = el.tagName.toLowerCase();

            // loading="lazy" must be set before src, otherwise the browser may
            // start fetching the new source eagerly.
            if ((tag === 'img' || tag === 'iframe') && !el.hasAttribute('loading')) {
                el.setAttribute('loading', 'lazy');
            }

            if (el.dataset.srcset) {
                el.setAttribute('srcset', el.dataset.srcset);
                el.removeAttribute('data-srcset');
            }

            if (el.dataset.src) {
                el.setAttribute('src', el.dataset.src);
                el.removeAttribute('data-src');
            }
        });
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => nativeLazyLoad());
    } else {
        nativeLazyLoad();
    }

    // Re-run when a section is re-rendered in the Shopify Theme Editor.
    document.addEventListener('shopify:section:load', (event) => {
        nativeLazyLoad(event.target || document);
    });
})();
